import { takeLatest } from 'redux-saga/effects';
import SagasHelper from "../../helpers/Redux/SagasHelper";
import { PRODUCTS_ACTIONS } from "./actionTypes";
import { ProductsApi } from "./api";
/**
 * Create product
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */

function* create(action) {
  yield SagasHelper.action(action, ProductsApi.create);
}
/**
 * Get product
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* view(action) {
  yield SagasHelper.action(action, ProductsApi.view);
}
/**
 * Get product by barcode
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* viewBarcode(action) {
  yield SagasHelper.action(action, ProductsApi.viewBarcode);
}
/**
 * Get products
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* list(action) {
  yield SagasHelper.action(action, ProductsApi.list);
}
/**
 * Update product
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* update(action) {
  yield SagasHelper.action(action, ProductsApi.update);
}
/**
 * Delete product
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* deleteModel(action) {
  yield SagasHelper.action(action, ProductsApi.delete);
}
/**
 * Add product to stock
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* addToStock(action) {
  yield SagasHelper.action(action, ProductsApi.addToStock);
}
/**
 * Upload products attachments
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* batchUpload(action) {
  yield SagasHelper.action(action, ProductsApi.batchUpload);
}
/**
 * Get list from categories
 *
 * @param {Array.<SearchQuery>} actions
 * @param {Array} action.categoriesId
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{products, type}>|CallEffect|PutEffect<{type}>>}
 */


function* pageLists(action) {
  yield SagasHelper.listsAction(action, ProductsApi.list);
}

export default [takeLatest(PRODUCTS_ACTIONS.CREATE, create), takeLatest(PRODUCTS_ACTIONS.VIEW, view), takeLatest(PRODUCTS_ACTIONS.VIEW_BARCODE, viewBarcode), takeLatest(PRODUCTS_ACTIONS.LIST, list), takeLatest(PRODUCTS_ACTIONS.SEARCH, list), takeLatest(PRODUCTS_ACTIONS.UPDATE, update), takeLatest(PRODUCTS_ACTIONS.DELETE, deleteModel), takeLatest(PRODUCTS_ACTIONS.ADD_TO_STOCK, addToStock), takeLatest(PRODUCTS_ACTIONS.BATCH_UPLOAD, batchUpload), takeLatest(PRODUCTS_ACTIONS.HOME_PAGE_LISTS, pageLists), takeLatest(PRODUCTS_ACTIONS.CATEGORIES_PAGE_LISTS, pageLists)];